import { render, staticRenderFns } from "./modalCompletarRegistro.vue?vue&type=template&id=feaedaee&scoped=true&"
import script from "./modalCompletarRegistro.vue?vue&type=script&lang=js&"
export * from "./modalCompletarRegistro.vue?vue&type=script&lang=js&"
import style0 from "./modalCompletarRegistro.vue?vue&type=style&index=0&id=feaedaee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feaedaee",
  null
  
)

export default component.exports